exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#productGoodsDataTable .ivu-table-border td,#productGoodsDataTable .ivu-table-border th{border-right:none}#productGoodsDataTable .ivu-table-wrapper{border-top:none}#productGoodsDataTable .ivu-table td,#productGoodsDataTable .ivu-table th{border-bottom:none}#productGoodsDataTable .ivu-progress-show-info .ivu-progress-outer{padding-right:15px;margin-right:-20px}", ""]);

// exports
